module.exports = __webpack_public_path__ + "static/matbuu-detail7-72aa2080b10d27e16d6735573ce06998.png";